import WithdrawCompletePage from '../../components/pages/accounts/WithdrawCompletePage.vue'
export default {
  components: { WithdrawCompletePage }
}
